import React from "react";

// Import all icons
import MyCropIcon from "../assets/Icon/MyCropsIcon.png";
import LabTestIcon from "../assets/Icon/LabTestIcon.png";
import FertlizerIcon from "../assets/Icon/FertilizersIcon.png";
import HarvestIcon from "../assets/Icon/HarvestIcon.png";
import AdvisoryIcon from "../assets/Icon/AdvisoryIcon.png";
import DecarbonizationIcon from "../assets/Icon/DecarbonizationIcon.png";
// FPO Icon
import DirectorsIcon from "../assets/Icon/DirectorsFpoIcon.png";
import OrganizationIcon from "../assets/Icon/OrganizationFpoIconpng.png";
import FinancialsIcon from "../assets/Icon/FinancialFpoIcon.png";
import DocumentIcon from "../assets/Icon/DocumentFpoIcon.png";
import SendLoanRequestIcon from "../assets/Icon/SendLoanRequestIcon.png";
import RecievedLoanIcon from "../assets/Icon/LoanRecievedIcon.png";
// Lender
import MyBorrowersIcon from "../assets/Icon/BorrowersIcon.png";
import ProspectIcon from "../assets/Icon/ProspectsIcon.png";
import MyLoanIcon from "../assets/Icon/MyLoanIcon.png";
import LenderIcon from "../assets/Icon/LenderIcon.png";
import LoanDocumentsIcon from "../assets/Icon/LoanDocumentsIcon.png";
//Buyer Icon
import CommodityBuyerIcon from "../assets/Icon/CommodityBuyerIcon.png";
import CropAnalyticsBuyerIcon from "../assets/Icon/CropAnalyticsBuyerIcon.png";
import PlantBuyerIcon from "../assets/Icon/PlantBuyerIcon.png";
import VentureBuyerIcon from "../assets/Icon/VentureBuyerIcon.png";
import MarketPlaceQL from "../assets/Icon/MarketPlaceQL.png";
//QuickLinks Icons
import MyCropQL from "../assets/Icon/MyCropQL.png";
import CropHealthQL from "../assets/Icon/CropHealthQL.png";
import DecarbonizationQL from "../assets/Icon/DecarbonizationQL.png";
import InputSupplyQL from "../assets/Icon/InputSupplyQL.png";
import LabTestQL from "../assets/Icon/LabTestQL.png";
import MarketRateQL from "../assets/Icon/MarketRateQL.png";
import MyHarvestQL from "../assets/Icon/MyHarvestQL.png";
import SatelliteDataQL from "../assets/Icon/SatelliteDataQL.png";
import DirectorsQL from "../assets/Icon/DirectorsQL.png";
import OrganizationDataQL from "../assets/Icon/OrganizationDataQL.png";
import FinancialQL from "../assets/Icon/FinancialQL.png";
import DocumentsQL from "../assets/Icon/DocumentsQL.png";
import AddFarmerQL from "../assets/Icon/AddFarmerQL.png";
import WhatsappUpdateQL from "../assets/Icon/WhatsappUpdateQL.png";
import CommoditiesQL from "../assets/Icon/CommoditiesQL.png";
import RequirementsQL from "../assets/Icon/RequirementsQL.png";
import TraceCropQL from "../assets/Icon/TraceCropQL.png";
import TradesQL from "../assets/Icon/TradesQL.png";
import ProgramIcon from "../assets/Icon/ProgramIcon.png";
import ProfileQL from "../assets/Icon/ProfileIconQL.png";
import ServiceQL from "../assets/Icon/ServiceIconQL.png";
import ServicesQL from "../assets/Icon/ServicesIconQL.png";
import WarehousesQL from "../assets/Icon/WarehousesIconQL.png";
import TutorialsQL from "../assets/Icon/TutorialsQL.png";
import CampaignsQL from "../assets/Icon/CampaignsQL.png";
import CropCareQL from "../assets/Icon/CropCareQL.png";
import NearestLabQL from "../assets/Icon/NearestLabQL.png";
import SatelliteDataReportQL from "../assets/Icon/SatelliteDataReportQL.png";
import DehaatMarketPlaceQL from "../assets/Icon/DehaatMarketPlaceQL.png";
import SoilTestingQL from "../assets/Icon/SoilTestingQL.png";
import ManageFarmersIcon from "../assets/icons/manage-farmers-icon.png";
import WeatherAlertsQL from "../assets/icons/weather-alerts-icon.png";

// Biochar
import biomassProcurementIcon from "../assets/icons/biochar/biomass-procurement-icon.png";
import pickupOrderIcon from "../assets/icons/biochar/pickup-order-icon.png";
import InwardQLIcon from "../assets/icons/goods-import-icon.png";
import ExpenseQLIcon from "../assets/icons/expense-tracker-icon.png";

const Icon = ({ type }) => {
  let icon;
  switch (type) {
    case "MyFarm":
      icon = MyCropQL;
      break;
    case "MyCrop":
      icon = MyCropIcon;
      break;
    case "LabTest":
      icon = LabTestIcon;
      break;
    case "Fertilizer":
      icon = FertlizerIcon;
      break;
    case "Harvest":
      icon = HarvestIcon;
      break;
    case "Advisory":
      icon = AdvisoryIcon;
      break;
    case "Decarbonization":
      icon = DecarbonizationIcon;
      break;
    case "directors":
      icon = DirectorsIcon;
      break;
    case "organization":
      icon = OrganizationIcon;
      break;
    case "financials":
      icon = FinancialsIcon;
      break;
    case "documents":
      icon = DocumentIcon;
      break;
    case "loan-request":
      icon = SendLoanRequestIcon;
      break;
    case "loan-received":
      icon = RecievedLoanIcon;
      break;
    //
    case "my-borrowers":
      icon = MyBorrowersIcon;
      break;
    case "prospects":
      icon = ProspectIcon;
      break;
    case "received-loan":
      icon = SendLoanRequestIcon;
      break;
    case "my-loan":
      icon = MyLoanIcon;
      break;
    case "see-all-lenders":
      icon = LenderIcon;
      break;
    case "loan-documents":
      icon = LoanDocumentsIcon;
      break;
    case "commodities":
      icon = CommodityBuyerIcon;
      break;
    case "trace":
      icon = PlantBuyerIcon;
      break;
    case "requirement":
      icon = CropAnalyticsBuyerIcon;
      break;
    case "trades":
      icon = VentureBuyerIcon;
      break;
    case "myCropQL":
      icon = MyCropQL;
      break;
    case "inputSupplyQL":
      icon = InputSupplyQL;
      break;
    case "myHarvestQL":
      icon = MyHarvestQL;
      break;
    case "labTestQL":
      icon = LabTestQL;
      break;
    case "manageFarmerQL":
      icon = ManageFarmersIcon;
      break;
    case "franchiseQL":
      icon = OrganizationIcon;
      break;
    case "program":
      icon = ProgramIcon;
      break;
    case "decarbonizationQL":
      icon = DecarbonizationQL;
      break;
    case "satelliteDataQL":
      icon = SatelliteDataQL;
      break;
    case "marketRateQL":
      icon = MarketRateQL;
      break;
    case "cropHealthQL":
      icon = CropHealthQL;
      break;
    case "directorsQL":
      icon = DirectorsQL;
      break;
    case "organizationDataQL":
      icon = OrganizationDataQL;
      break;
    case "financialQL":
      icon = FinancialQL;
      break;
    case "documentsQL":
      icon = DocumentsQL;
      break;
    case "addFarmerQL":
      icon = AddFarmerQL;
      break;
    case "whatsappUpdateQL":
      icon = WhatsappUpdateQL;
      break;
    case "commoditiesQL":
      icon = CommoditiesQL;
      break;
    case "traceQL":
      icon = TraceCropQL;
      break;
    case "requirementsQL":
      icon = RequirementsQL;
      break;
    case "tradesQL":
      icon = TradesQL;
      break;
    case "profileQL":
      icon = ProfileQL;
      break;
    case "serviceQL":
      icon = ServiceQL;
      break;
    case "servicesQL":
      icon = ServicesQL;
      break;
    case "warehousesQL":
      icon = WarehousesQL;
      break;
    case "tutorialsQL":
      icon = TutorialsQL;
      break;
    case "marketPlaceQL":
      icon = MarketPlaceQL;
      break;
    case "campaignsQL":
      icon = CampaignsQL;
      break;
    case "cropCareQL":
      icon = CropCareQL;
      break;
    case "nearestLabQL":
      icon = NearestLabQL;
      break;
    case "satelliteDataReportQL":
      icon = SatelliteDataReportQL;
      break;
    case "soilTestingQL":
      icon = SoilTestingQL;
      break;
    case "biomassProcurement":
      icon = biomassProcurementIcon;
      break;
    case "pickupOrder":
      icon = pickupOrderIcon;
      break;
    case "inwardsQL":
      icon = InwardQLIcon;
      break;
    case "expenseQL":
      icon = ExpenseQLIcon;
      break;
    case "dehaatMarketPlaceQL":
      icon = DehaatMarketPlaceQL;
      break;
    case "WeatherAlertsQL":
      icon = WeatherAlertsQL;
      break;
    default:
      icon = null;
  }

  return icon ? (
    <img src={icon} alt={type} style={{ width: 73, height: 73 }} />
  ) : null;
};

export default Icon;
